import React from "react";
import { Table } from "antd";
import moment from 'moment';
import "moment/locale/en-nz"
//import { showApiError, renderFooterTable } from '../utilities'


function renderFooterTable(total, rebate, columns, titleCol, size) {
  const dataList = [{
      contributionLineId: 0,
        "contributorId": 0,
        "fund": "",
        "amount": total,
        "rebatePercentage": "",
        "rebateAmount": rebate,
        "contributionDate": "Total",
        "displayName": "",
        "offeringNo": 0
  }];
  return (
    <Table
      rowKey='contributionLineId'
      className="footer"
      pagination={false}
      size={size}
      showHeader={false}
      columns={columns}
      rowClassName={"footer"}
      dataSource={dataList}
    />
  );
}


function DetailReportContent(props) {
  let columns = [
    {
      title: "Contribution Date",
      dataIndex: "contributionDate",
      key: "contributionDate",
      render: (item) => <span>{ item==='Total'? 'Total' : moment(item).format("DD/MM/YYYY")}</span>,
      width: '150px'
    },
    {
      title: "Fund",
      dataIndex: "fund",
      align: 'left',
      width: '250px'
      
    },
    {
      title: "Amount",
      dataIndex: "amount",
      align: 'right',
      width: '100px',
      render: (item) => <span>{item.toFixed(2)}</span>
    },
    {
      title: "Rebate %",
      dataIndex: "rebatePercentage",
      align: 'right',
      width: '100px',
    },
    {
      title: "Rebate Amount",
      dataIndex: "rebateAmount",
      align: 'right',
      width: '100px',
      render: (item) => <span>{item.toFixed(2)}</span>
    }
  ];

  let reduceArray = props.data.reduce( (acc, item) => {
    acc.amount = acc.amount + item.amount
    acc.rebate = acc.rebate + item.rebateAmount
    return acc
  }, { amount:0 , rebate: 0} )

  return (
    <div className="center " >
      <h2>Statement of contributions</h2>
      <h4>{props.displayName}</h4>
      <Table dataSource={props.data} columns={columns} 
        rowKey="contributionLineId" pagination={false}
            size="middle"/>
      {renderFooterTable( reduceArray.amount, reduceArray.rebate, columns, "", "middle"  )}
    </div>
  );
}

export default DetailReportContent;
